import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  introContent: string= "I am a Web Developer, Android Developer, UI/UX Designer. Deep Learning Enthusiast, Cloud Computing Enthusiast";

  aboutContent: string = "I am currently a Final year student at The Pimpri Chinchwad College Of Engineering, Pune and pursuing my B.E (Computer Engineering) from here. I am a self taught Web Developer, currently diving deeper into Machine Learning. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them."

  backgroundContent: string = "I develop Web Application and also android application."

  skillSets: string[] = ["Serverless", "Junit", "Redux", "Docker", "Terraform", "AWS Services"]
  constructor() { }

  ngOnInit() {
  }

}
